import { useState } from "react";
import { tr } from "../lib/i18n";

const THEMES = ["modern", "luxury", "classic", "bold"];

// Pick a public website theme; preview it live in a frame before applying (saved with the other settings).
export const ThemePicker = ({ value, onApply }) => {
  const [preview, setPreview] = useState(null);
  const current = value || "modern";
  return (
    <div className="grid gap-3" data-testid="theme-picker">
      <div className="grid gap-2" style={{ gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))" }}>
        {THEMES.map((th) => (
          <div key={th} className="border rounded-lg p-3" style={{ borderColor: th === current ? "var(--accent)" : undefined, borderWidth: th === current ? 2 : 1 }} data-testid={`theme-card-${th}`}>
            <div className="font-semibold">{tr(`x.theme_${th /* i18n-keys: modern,luxury,classic,bold */}`)}</div>
            <div className="text-xs text-[var(--gray-400)] mt-1">{tr(`x.theme_${th /* i18n-keys: modern,luxury,classic,bold */}_help`)}</div>
            <div className="flex gap-2 mt-3">
              <button type="button" className="btn-ghost text-xs" onClick={() => setPreview(th)} data-testid={`theme-preview-${th}`}>{tr("x.theme_preview")}</button>
              {th === current ? <span className="text-xs font-semibold" data-testid={`theme-current-${th}`}>{tr("x.theme_current")}</span>
                : <button type="button" className="btn-primary text-xs" onClick={() => onApply(th)} data-testid={`theme-apply-${th}`}>{tr("x.theme_apply")}</button>}
            </div>
          </div>
        ))}
      </div>
      {preview && (
        <div className="border rounded-lg overflow-hidden" data-testid="theme-preview-frame">
          <div className="flex items-center justify-between p-2 text-sm bg-[hsl(var(--card))]">
            <span>{tr("x.theme_preview")}: {tr(`x.theme_${preview /* i18n-keys: modern,luxury,classic,bold */}`)}</span>
            <button type="button" className="btn-ghost text-xs" onClick={() => setPreview(null)} data-testid="theme-preview-close">{tr("x.close")}</button>
          </div>
          <iframe title={tr("x.theme_preview")} src={`/?preview_theme=${preview}`} style={{ width: "100%", height: 520, border: 0 }} />
        </div>
      )}
    </div>
  );
};
